import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { LanguageService, TranslationService } from '@dch/ng-common';
import { tap } from 'rxjs/operators';

import { getAppInitializationRequest } from '../state/actions';
import {
  getCustomerAccountRequest,
  setCustomerLanguage,
} from '../state/actions/customer.actions';
import { ApplicationState } from '../state/reducers';
import { selectAppInitialization } from '../state/selectors/app-initialization.selectors';
import { OnDestroyHookDirective } from './common/hooks';
import packageInfo from '../../../package.json';

@Component({
  selector: 'my-bill-app',
  templateUrl: './my-bill-app.component.html',
  standalone: false,
})
export class MyBillAppComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  readonly selectAppInitialization$ = this.store.select(
    selectAppInitialization
  );
  version?: string;
  translationsLoaded = false;
  @ViewChild('loadBundledTranslationsComponent', { read: ViewContainerRef })
  loadBundledTranslationsComponent!: ViewContainerRef;

  constructor(
    private languageService: LanguageService,
    private store: Store<ApplicationState>,
    private router: Router,
    private translationService: TranslationService,
    private elementRef: ElementRef
  ) {
    super();
  }

  ngOnInit() {
    this.version = packageInfo?.version;
    this.translationService.parse(this.elementRef.nativeElement);
    this.store.dispatch(
      setCustomerLanguage({
        language: this.languageService.getSelectedLanguage() as
          | 'en'
          | 'fr'
          | 'nl'
          | 'de',
      })
    );
    if (!this.translationsLoaded) {
      this.store.dispatch(getAppInitializationRequest());
    }

    this.store.dispatch(getCustomerAccountRequest());
    this.selectAppInitialization$
      .pipe(
        tap((appState) => {
          if (appState.initialized) {
            this.router.initialNavigation();
          }
          if (appState.failed) {
            this.loadBundledTranslations();
            this.translationsLoaded = true;
          }
        })
      )
      .subscribe();
  }

  async loadBundledTranslations() {
    const { LoadBundledTranslationsComponent } = await import(
      '../bundled-translations/load-bundled-translations.component'
    );
    this.loadBundledTranslationsComponent.clear();
    this.loadBundledTranslationsComponent.createComponent(
      LoadBundledTranslationsComponent
    );
  }
}
